import { useQuery } from "@apollo/react-hooks";

import todaysThingsToDo from "../graph-ql/todaysThingsToDo.graphql";

import { Learner } from "@hubcapp/types";

const useQueryGetTodaysThingsToDo = ({
  instructorId,
}: {
  instructorId: string;
}) =>
  useQuery<{ instructor: { learners: Learner[] } }>(todaysThingsToDo, {
    variables: { id: instructorId },
    fetchPolicy: "cache-first",
    skip: !instructorId,
  });

export default useQueryGetTodaysThingsToDo;
